import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';

const CONTACT_INFO = {
  address: "Jl. Gaperta No. 218 A Medan Helvetia",
  email: "mytentor2017@gmail.com",
  phone: "+62 812 6201 7001",
  whatsapp: "6281262017001",
  hours: "08.00 WIB - 19.00 WIB",
  youtube: "https://www.youtube.com/@mytentor7112"
};

export function Footer() {
  return (
    <footer className="bg-slate-950 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-mytentor.png" alt="MyTentor Logo" className="w-10 h-10 object-contain" />
              <span className="text-lg font-bold">Bimbel My Tentor</span>
            </div>
            <p className="text-slate-400 text-sm mb-4">
              Platform Try Out Online terpercaya untuk persiapan UTBK-SNBT, CPNS, TNI, POLRI, Kedinasan, dan SMA Favorit.
            </p>
            <div className="flex items-center gap-3">
              <a 
                href={`https://wa.me/${CONTACT_INFO.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-green-600 hover:bg-green-700 rounded-full flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
              <a 
                href={CONTACT_INFO.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors"
                aria-label="YouTube"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a 
                href={`mailto:${CONTACT_INFO.email}`}
                className="w-9 h-9 bg-slate-700 hover:bg-slate-600 rounded-full flex items-center justify-center transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Program */}
          <div>
            <h4 className="font-semibold mb-4">Program</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/tryouts?program=UTBK-SNBT" className="hover:text-white transition-colors">UTBK-SNBT</Link></li>
              <li><Link to="/tryouts?program=CPNS" className="hover:text-white transition-colors">CPNS</Link></li>
              <li><Link to="/tryouts?program=TNI" className="hover:text-white transition-colors">Tes TNI</Link></li>
              <li><Link to="/tryouts?program=POLRI" className="hover:text-white transition-colors">Tes Polri</Link></li>
              <li><Link to="/tryouts?program=KEDINASAN" className="hover:text-white transition-colors">Sekolah Kedinasan</Link></li>
              <li><Link to="/tryouts?program=SMA" className="hover:text-white transition-colors">SMA Favorit</Link></li>
            </ul>
          </div>
          
          {/* Layanan */}
          <div>
            <h4 className="font-semibold mb-4">Layanan</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/tryouts" className="hover:text-white transition-colors">Try Out Online</Link></li>
              <li><Link to="/packages" className="hover:text-white transition-colors">Paket Belajar</Link></li>
              <li><Link to="/ranking" className="hover:text-white transition-colors">Ranking & Leaderboard</Link></li>
              <li><a href={CONTACT_INFO.youtube} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Video Pembelajaran</a></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ / Bantuan</Link></li>
            </ul>
          </div>
          
          {/* Kontak */}
          <div>
            <h4 className="font-semibold mb-4">Kontak Kami</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-slate-500 mt-0.5 shrink-0" />
                <span>{CONTACT_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-slate-500 shrink-0" />
                <a href={`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`} className="hover:text-white transition-colors">
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-slate-500 shrink-0" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white transition-colors">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-slate-500 shrink-0" />
                <span>Senin - Sabtu: {CONTACT_INFO.hours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-400">
              &copy; {new Date().getFullYear()} Bimbel My Tentor. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-slate-400">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Kebijakan Privasi
              </Link>
              <Link to="/terms" className="hover:text-white transition-colors">
                Syarat & Ketentuan
              </Link>
              <Link to="/faq" className="hover:text-white transition-colors">
                FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
